import { createApp, watch } from 'vue';
import { createPinia } from 'pinia';
import { MotionPlugin } from '@vueuse/motion';
import { Toaster } from 'vue-sonner';
import App from './App.vue';
import { router } from './router';
import './styles/global.css';
import { useAuthStore } from './stores/auth';
import { useSocket } from './composables/useSocket';

async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);
  app.use(router);
  app.use(MotionPlugin);

  // Initialize auth (load current user from cookie)
  const auth = useAuthStore();
  await auth.fetchMe().catch(() => {});

  // React to login / logout: connect or tear down the realtime socket
  // accordingly. `immediate: true` also covers the "page reloaded while
  // already authenticated" case so we don't need a separate connect() call.
  const realtime = useSocket();
  watch(
    () => auth.user,
    (user) => {
      if (user) realtime.connect();
      else realtime.disconnect();
    },
    { immediate: true }
  );

  app.component('Toaster', Toaster);
  app.mount('#app');
}

bootstrap();
